"use strict";

exports.__esModule = true;
var _DeviceScreen = require("./DeviceScreen");
Object.keys(_DeviceScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceScreen[key]) return;
  exports[key] = _DeviceScreen[key];
});